function Textbox({ id, value, onChange, placeholder }) {
    return (
        <input
            id={id}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            type="text"
            placeholder={placeholder}
            className="auth-textbox textboxes w-full"
        />
    );
}

export default Textbox;
